<template>
  <div class="product-list">
    <div class="container-box">
      <div class="product-content">
        <div style="margin-bottom: 10px">
          <el-button size="small" type="primary" @click="allRead()">{{ $t('全部标记为已读') }}</el-button>
        </div>
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="title" :label="$t('标题内容')">
              <template slot-scope="scope">
                <div v-if="scope.row.isRead == 1" style="cursor: pointer" @click="lookNoticeDetail(scope.row)">
                  <span style="color: #999999;">{{ scope.row.title }}</span>
                </div>
                <div v-else style="cursor: pointer" @click="lookNoticeDetail(scope.row)">
                  <span style="color: rgb(0, 100, 200);font-size: 20px">●</span>
                  <span>{{ scope.row.title }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" :label="$t('发布时间')"></el-table-column>
          </el-table>
        </div>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
      <el-dialog :title="$t('公告详情')" :visible.sync="dialogVisible" width="50%">
        <div style="text-align: center;margin-bottom: 20px">
          <h2>{{ notice_title }}</h2>
          <div style="margin-bottom: 20px;margin-top: 10px">
            <span>{{ $t('发布时间') }}: {{ create_time }}</span>
          </div>
          <div style="font-size: 18px">
            <p>{{ notice_content }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import NoticeApi from '@/api/notice.js';
import bus from '@/utils/eventBus.js';
import { langConfigList } from '@/utils/config.js'
export default {
  components: {},
  data() {
    return {
      mainLanguage: "chinese",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*列表数据*/
      tableData: [],
      dialogVisible: false,
      notice_title: "",
      notice_content: "",
      create_time: "",
      langList: langConfigList
    };
  },
  created() {
    if (localStorage.getItem('lang-select')) {
      const lang = localStorage.getItem("lang-select");
      const target = this.langList.find(item => item.value === lang)
      if (target) {
        this.mainLanguage = target.text
      }
    } else {
      localStorage.setItem("lang-select", 'chinese');
    }
    /*获取列表*/
    this.getData();

    bus.$on('langChanged', res => {
      this.mainLanguage = res
      this.getData()
    });
  },
  beforeDestroy() {
    bus.$off('langChanged');
  },
  methods: {
    allRead() {
      const self = this
      self.$confirm(self.$t('全部标记为已读消息吗?'), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        NoticeApi.readAllNotice({}, true)
          .then(data => {
            self.getData();
            bus.$emit('hasNoReadNotice', false);
            self.$message({
              type: 'success',
              message: self.$t('操作成功!')
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        self.$message({
          type: 'info',
          message: self.$t('已取消操作')
        });
      });
    },
    lookNoticeDetail(row) {
      this.dialogVisible = true
      this.notice_title = row.title
      this.notice_content = row.content
      this.create_time = row.create_time

      if (row.isRead == 0) {
        //这里标记该条公告已读状态
        NoticeApi.readNotice({ notice_id: row.id }, true)
          .then(data => {
            this.getData();
            this.getUnReadNoticeCount()
          })
          .catch(error => {
          });
      }
    },

    getUnReadNoticeCount() {
      NoticeApi.hasUnreadNotice({}, true)
        .then(data => {
          if (data.data.count > 0) {
            bus.$emit('hasNoReadNotice', true);
          } else {
            bus.$emit('hasNoReadNotice', false);
          }
        })
        .catch(error => {
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.type = self.activeName;
      Params.language = this.mainLanguage;
      self.loading = true;
      NoticeApi.noticeList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/setting/settings/notice/notice.vue